var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRatingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_3790668_rate_rating_survey_icon",
    "data-name": "3790668_rate_rating_survey_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.865,
    height: 61.151,
    viewBox: "0 0 76.865 61.151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2760",
    "data-name": "Group 2760",
    transform: "translate(0 46.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7855",
    "data-name": "Path 7855",
    d: "M51.66,356.023l1.849,3.747,4.135.6-2.992,2.917.706,4.119-3.7-1.945-3.7,1.945.706-4.119-2.992-2.917,4.135-.6Z",
    transform: "translate(-43.931 -354.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7856",
    "data-name": "Path 7856",
    d: "M39.7,360.9a1.744,1.744,0,0,1-1.719-2.039l.551-3.215L36.2,353.365a1.744,1.744,0,0,1,.967-2.976l3.228-.469L41.839,347a1.744,1.744,0,0,1,3.128,0l1.444,2.925,3.228.469a1.744,1.744,0,0,1,.967,2.976l-2.336,2.277.551,3.215A1.745,1.745,0,0,1,46.29,360.7L43.4,359.177,40.516,360.7A1.742,1.742,0,0,1,39.7,360.9Zm3.7-5.433a1.744,1.744,0,0,1,.812.2l.571.3-.109-.635a1.744,1.744,0,0,1,.5-1.544l.461-.45L45,353.241a1.744,1.744,0,0,1-1.313-.954l-.285-.578-.285.578a1.745,1.745,0,0,1-1.313.954l-.638.093.461.45a1.744,1.744,0,0,1,.5,1.544l-.109.635.57-.3A1.743,1.743,0,0,1,43.4,355.462Z",
    transform: "translate(-35.674 -346.023)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2761",
    "data-name": "Group 2761",
    transform: "translate(20.469 46.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7857",
    "data-name": "Path 7857",
    d: "M169,356.023l1.849,3.747,4.135.6L172,363.288l.706,4.119-3.7-1.945-3.7,1.945.706-4.119-2.992-2.917,4.135-.6Z",
    transform: "translate(-161.275 -354.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7858",
    "data-name": "Path 7858",
    d: "M157.049,360.9a1.744,1.744,0,0,1-1.719-2.039l.551-3.215-2.335-2.277a1.744,1.744,0,0,1,.967-2.976l3.228-.469L159.183,347a1.744,1.744,0,0,1,3.128,0l1.444,2.925,3.228.469a1.744,1.744,0,0,1,.967,2.976l-2.336,2.277.551,3.215a1.745,1.745,0,0,1-2.531,1.839l-2.887-1.518L157.86,360.7A1.742,1.742,0,0,1,157.049,360.9Zm3.7-5.433a1.744,1.744,0,0,1,.812.2l.571.3-.109-.635a1.744,1.744,0,0,1,.5-1.544l.461-.45-.638-.093a1.745,1.745,0,0,1-1.313-.954l-.285-.578-.285.578a1.745,1.745,0,0,1-1.313.954l-.638.093.461.45a1.744,1.744,0,0,1,.5,1.544l-.109.635.57-.3A1.743,1.743,0,0,1,160.747,355.462Z",
    transform: "translate(-153.018 -346.023)",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2762",
    "data-name": "Group 2762",
    transform: "translate(40.938 46.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7859",
    "data-name": "Path 7859",
    d: "M286.347,356.023l1.85,3.747,4.135.6-2.992,2.917.706,4.119-3.7-1.945-3.7,1.945.706-4.119-2.992-2.917,4.135-.6Z",
    transform: "translate(-278.619 -354.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7860",
    "data-name": "Path 7860",
    d: "M281.79,360.9a1.744,1.744,0,0,1-.811-.2l-2.887-1.518L275.2,360.7a1.744,1.744,0,0,1-2.531-1.839l.551-3.215-2.335-2.277a1.745,1.745,0,0,1,.967-2.975l3.228-.469L276.527,347a1.744,1.744,0,0,1,3.128,0l1.444,2.925,3.228.469a1.745,1.745,0,0,1,.967,2.976l-2.336,2.277.551,3.215a1.745,1.745,0,0,1-1.719,2.039Zm-3.7-5.433a1.744,1.744,0,0,1,.812.2l.571.3-.109-.635a1.745,1.745,0,0,1,.5-1.544l.462-.45-.638-.093a1.744,1.744,0,0,1-1.313-.954l-.285-.578-.285.578a1.745,1.745,0,0,1-1.313.954l-.638.093.461.45a1.745,1.745,0,0,1,.5,1.544l-.109.635.57-.3A1.744,1.744,0,0,1,278.091,355.462Z",
    transform: "translate(-270.362 -346.023)",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2763",
    "data-name": "Group 2763",
    transform: "translate(61.407 46.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7861",
    "data-name": "Path 7861",
    d: "M403.691,356.023l1.85,3.747,4.135.6-2.992,2.917.706,4.119-3.7-1.945-3.7,1.945.706-4.119-2.992-2.917,4.135-.6Z",
    transform: "translate(-395.963 -354.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7862",
    "data-name": "Path 7862",
    d: "M399.134,360.9a1.744,1.744,0,0,1-.811-.2l-2.887-1.518-2.887,1.518a1.745,1.745,0,0,1-2.531-1.839l.551-3.215-2.336-2.277a1.744,1.744,0,0,1,.967-2.975l3.228-.469L393.871,347A1.744,1.744,0,0,1,397,347l1.444,2.925,3.228.469a1.745,1.745,0,0,1,.967,2.976l-2.336,2.277.551,3.215a1.745,1.745,0,0,1-1.719,2.039Zm-3.7-5.433a1.744,1.744,0,0,1,.812.2l.571.3-.109-.635a1.745,1.745,0,0,1,.5-1.544l.462-.45-.638-.093a1.744,1.744,0,0,1-1.313-.954l-.285-.578-.285.578a1.745,1.745,0,0,1-1.313.954l-.638.093.461.45a1.745,1.745,0,0,1,.5,1.544l-.109.635.57-.3A1.744,1.744,0,0,1,395.435,355.462Z",
    transform: "translate(-387.706 -346.023)",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2764",
    "data-name": "Group 2764",
    transform: "translate(15.743 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7863",
    "data-name": "Path 7863",
    d: "M134.754,119.486a1.744,1.744,0,0,1-1.719-2.039l2.034-11.861-8.616-8.4a1.744,1.744,0,0,1,.967-2.975l11.908-1.73,5.325-10.791a1.744,1.744,0,0,1,3.128,0l5.326,10.79,11.909,1.73a1.745,1.745,0,0,1,.967,2.976l-8.617,8.4,2.034,11.861a1.745,1.745,0,0,1-2.531,1.839l-10.652-5.6-10.651,5.6A1.744,1.744,0,0,1,134.754,119.486Zm11.463-9.516a1.744,1.744,0,0,1,.812.2l8.335,4.382-1.592-9.281a1.745,1.745,0,0,1,.5-1.544l6.743-6.573L151.7,95.8a1.745,1.745,0,0,1-1.313-.954L146.217,86.4l-4.167,8.443a1.745,1.745,0,0,1-1.313.954l-9.318,1.354,6.742,6.573a1.744,1.744,0,0,1,.5,1.544l-1.592,9.281,8.334-4.382A1.746,1.746,0,0,1,146.217,109.97Z",
    transform: "translate(-125.926 -80.718)",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2765",
    "data-name": "Group 2765",
    transform: "translate(0 46.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7864",
    "data-name": "Path 7864",
    d: "M51.66,356.023l1.849,3.747,4.135.6-2.992,2.917.706,4.119-3.7-1.945-3.7,1.945.706-4.119-2.992-2.917,4.135-.6Z",
    transform: "translate(-43.931 -354.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7865",
    "data-name": "Path 7865",
    d: "M39.7,360.9a1.744,1.744,0,0,1-1.719-2.039l.551-3.215L36.2,353.365a1.744,1.744,0,0,1,.967-2.976l3.228-.469L41.839,347a1.744,1.744,0,0,1,3.128,0l1.444,2.925,3.228.469a1.744,1.744,0,0,1,.967,2.976l-2.336,2.277.551,3.215A1.745,1.745,0,0,1,46.29,360.7L43.4,359.177,40.516,360.7A1.742,1.742,0,0,1,39.7,360.9Zm3.7-5.433a1.744,1.744,0,0,1,.812.2l.571.3-.109-.635a1.744,1.744,0,0,1,.5-1.544l.461-.45L45,353.241a1.744,1.744,0,0,1-1.313-.954l-.285-.578-.285.578a1.745,1.745,0,0,1-1.313.954l-.638.093.461.45a1.744,1.744,0,0,1,.5,1.544l-.109.635.57-.3A1.743,1.743,0,0,1,43.4,355.462Z",
    transform: "translate(-35.674 -346.023)",
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2766",
    "data-name": "Group 2766",
    transform: "translate(20.469 46.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7866",
    "data-name": "Path 7866",
    d: "M169,356.023l1.849,3.747,4.135.6L172,363.288l.706,4.119-3.7-1.945-3.7,1.945.706-4.119-2.992-2.917,4.135-.6Z",
    transform: "translate(-161.275 -354.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7867",
    "data-name": "Path 7867",
    d: "M157.049,360.9a1.744,1.744,0,0,1-1.719-2.039l.551-3.215-2.335-2.277a1.744,1.744,0,0,1,.967-2.976l3.228-.469L159.183,347a1.744,1.744,0,0,1,3.128,0l1.444,2.925,3.228.469a1.744,1.744,0,0,1,.967,2.976l-2.336,2.277.551,3.215a1.745,1.745,0,0,1-2.531,1.839l-2.887-1.518L157.86,360.7A1.742,1.742,0,0,1,157.049,360.9Zm3.7-5.433a1.744,1.744,0,0,1,.812.2l.571.3-.109-.635a1.744,1.744,0,0,1,.5-1.544l.461-.45-.638-.093a1.745,1.745,0,0,1-1.313-.954l-.285-.578-.285.578a1.745,1.745,0,0,1-1.313.954l-.638.093.461.45a1.744,1.744,0,0,1,.5,1.544l-.109.635.57-.3A1.743,1.743,0,0,1,160.747,355.462Z",
    transform: "translate(-153.018 -346.023)",
    fill: "#fff"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2767",
    "data-name": "Group 2767",
    transform: "translate(40.938 46.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7868",
    "data-name": "Path 7868",
    d: "M286.347,356.023l1.85,3.747,4.135.6-2.992,2.917.706,4.119-3.7-1.945-3.7,1.945.706-4.119-2.992-2.917,4.135-.6Z",
    transform: "translate(-278.619 -354.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7869",
    "data-name": "Path 7869",
    d: "M281.79,360.9a1.744,1.744,0,0,1-.811-.2l-2.887-1.518L275.2,360.7a1.744,1.744,0,0,1-2.531-1.839l.551-3.215-2.335-2.277a1.745,1.745,0,0,1,.967-2.975l3.228-.469L276.527,347a1.744,1.744,0,0,1,3.128,0l1.444,2.925,3.228.469a1.745,1.745,0,0,1,.967,2.976l-2.336,2.277.551,3.215a1.745,1.745,0,0,1-1.719,2.039Zm-3.7-5.433a1.744,1.744,0,0,1,.812.2l.571.3-.109-.635a1.745,1.745,0,0,1,.5-1.544l.462-.45-.638-.093a1.744,1.744,0,0,1-1.313-.954l-.285-.578-.285.578a1.745,1.745,0,0,1-1.313.954l-.638.093.461.45a1.745,1.745,0,0,1,.5,1.544l-.109.635.57-.3A1.744,1.744,0,0,1,278.091,355.462Z",
    transform: "translate(-270.362 -346.023)",
    fill: "#fff"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2768",
    "data-name": "Group 2768",
    transform: "translate(61.407 46.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7870",
    "data-name": "Path 7870",
    d: "M403.691,356.023l1.85,3.747,4.135.6-2.992,2.917.706,4.119-3.7-1.945-3.7,1.945.706-4.119-2.992-2.917,4.135-.6Z",
    transform: "translate(-395.963 -354.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7871",
    "data-name": "Path 7871",
    d: "M399.134,360.9a1.744,1.744,0,0,1-.811-.2l-2.887-1.518-2.887,1.518a1.745,1.745,0,0,1-2.531-1.839l.551-3.215-2.336-2.277a1.744,1.744,0,0,1,.967-2.975l3.228-.469L393.871,347A1.744,1.744,0,0,1,397,347l1.444,2.925,3.228.469a1.745,1.745,0,0,1,.967,2.976l-2.336,2.277.551,3.215a1.745,1.745,0,0,1-1.719,2.039Zm-3.7-5.433a1.744,1.744,0,0,1,.812.2l.571.3-.109-.635a1.745,1.745,0,0,1,.5-1.544l.462-.45-.638-.093a1.744,1.744,0,0,1-1.313-.954l-.285-.578-.285.578a1.745,1.745,0,0,1-1.313.954l-.638.093.461.45a1.745,1.745,0,0,1,.5,1.544l-.109.635.57-.3A1.744,1.744,0,0,1,395.435,355.462Z",
    transform: "translate(-387.706 -346.023)",
    fill: "#fff"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2769",
    "data-name": "Group 2769",
    transform: "translate(15.743 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7872",
    "data-name": "Path 7872",
    d: "M154.473,90.717,160.2,102.33l12.817,1.862-9.274,9.04L165.936,126l-11.463-6.027L143.01,126l2.189-12.764-9.273-9.04,12.815-1.862Z",
    transform: "translate(-134.182 -88.973)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7873",
    "data-name": "Path 7873",
    d: "M134.754,119.486a1.744,1.744,0,0,1-1.719-2.039l2.034-11.861-8.616-8.4a1.744,1.744,0,0,1,.967-2.975l11.908-1.73,5.325-10.791a1.744,1.744,0,0,1,3.128,0l5.326,10.79,11.909,1.73a1.745,1.745,0,0,1,.967,2.976l-8.617,8.4,2.034,11.861a1.745,1.745,0,0,1-2.531,1.839l-10.652-5.6-10.651,5.6A1.744,1.744,0,0,1,134.754,119.486Zm11.463-9.516a1.744,1.744,0,0,1,.812.2l8.335,4.382-1.592-9.281a1.745,1.745,0,0,1,.5-1.544l6.743-6.573L151.7,95.8a1.745,1.745,0,0,1-1.313-.954L146.217,86.4l-4.167,8.443a1.745,1.745,0,0,1-1.313.954l-9.318,1.354,6.742,6.573a1.744,1.744,0,0,1,.5,1.544l-1.592,9.281,8.334-4.382A1.746,1.746,0,0,1,146.217,109.97Z",
    transform: "translate(-125.926 -80.718)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingIcon);
export default __webpack_public_path__ + "static/media/rating-icon.b51ee7774a9e1aadd81880494325a314.svg";
export { ForwardRef as ReactComponent };